import React from 'react'
import { useTranslation } from 'react-i18next'
import { IconArrow } from 'Stories/Icon/Icon.stories'

import { PageTitleContainer, PageTitle, BackButton } from './styles'

const DetailsHeader = () => {
  const { t } = useTranslation()

  const handleGoBack = () => {
    history.go(-1)
  }

  return (
    <PageTitleContainer onClick={handleGoBack}>
      <BackButton>
        <IconArrow />
      </BackButton>
      <PageTitle>{t('campaignResultsPage.pageTitle')}</PageTitle>
    </PageTitleContainer>
  )
}

export default DetailsHeader
